<template>
  <el-dialog
    title="核销单打印"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="860px"
    class="billsCreateDialog"
    @close="dialogCloseHandle"
  >
    <div class="wrapper">
      <div class="btnBar">
        <el-button type="primary" @click="printHandler">打印</el-button>
      </div>
      <!--      <div id="generatedContent" class="generatedContent">-->
      <!--        <div class="title">-->
      <!--          <div>-->
      <!--            <div ref="qrcode" class="qrCode" />-->
      <!--            <div class="text">锐捷网络有限公司2022年 新市场活动核销单（渠道）</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="container">-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">经办人</div>-->
      <!--              <div class="text">{{ printData.handler }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">单据编号</div>-->
      <!--              <div class="text">{{ printData.instanceCode }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="6">-->
      <!--              <div class="label">核销人</div>-->
      <!--              <div class="text">{{ printData.writeOffPerson }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="6">-->
      <!--              <div class="label">区域</div>-->
      <!--              <div class="text">{{ printData.region }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="6">-->
      <!--              <div class="label">部门</div>-->
      <!--              <div class="text">{{ printData.departMentName }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="6">-->
      <!--              <div class="label">岗位</div>-->
      <!--              <div class="text">{{ printData.postName }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">货币种类</div>-->
      <!--              <div class="text">{{ printData.currency }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">汇率</div>-->
      <!--              <div class="text">{{ printData.exchangeRate }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="8">-->
      <!--              <div class="label">填单日期</div>-->
      <!--              <div class="text">{{ printData.fillFromDate }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="8">-->
      <!--              <div class="label">核销金额</div>-->
      <!--              <div class="text">{{ printData.writeOffAmount }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="8">-->
      <!--              <div class="label">实付金额</div>-->
      <!--              <div class="text">{{ printData.realPayAmount }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">借款冲销情况</div>-->
      <!--              <div class="text">无</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">借款总金额</div>-->
      <!--              <div class="text" />-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="24">-->
      <!--              <div class="label">活动单号</div>-->
      <!--              <div class="text">{{ printData.activityCode }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="24">-->
      <!--              <div class="label">用款说明</div>-->
      <!--              <div class="text">无</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">开支金额</div>-->
      <!--              <div class="text">（大写）{{ printData.aa }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="12">-->
      <!--              <div class="text">（小写）{{ printData.realPayAmount }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="12">-->
      <!--              <div class="label">实付金额</div>-->
      <!--              <div class="text">（大写）{{ printData.aa }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="12">-->
      <!--              <div class="text">（小写）{{ printData.realPayAmount }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="24">-->
      <!--              <div class="title">营销费用明细</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="longitudinal">-->
      <!--            <el-col :span="4">-->
      <!--              <div class="label">费用归属</div>-->
      <!--              <div class="text">{{ printData.expenseDeptName }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">费用项目</div>-->
      <!--              <div class="text">{{ printData.expenseType }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">申请使用金额</div>-->
      <!--              <div class="text">{{ printData.applyAmount }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">借款金额</div>-->
      <!--              <div class="text">{{ printData.aa }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">分摊核销金额</div>-->
      <!--              <div class="text">{{ printData.aa }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="24">-->
      <!--              <div class="title">付款明细</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="longitudinal">-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">户名</div>-->
      <!--              <div class="text">{{ printData.bankAcountName }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="4">-->
      <!--              <div class="label">付款方式</div>-->
      <!--              <div class="text">{{ printData.payType }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">账号</div>-->
      <!--              <div class="text">{{ printData.bankAcount }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">开户银行</div>-->
      <!--              <div class="text">{{ printData.bankName }}</div>-->
      <!--            </el-col>-->
      <!--            <el-col :span="5">-->
      <!--              <div class="label">实付金额</div>-->
      <!--              <div class="text">{{ printData.realPayAmount }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--          <el-row class="transverse">-->
      <!--            <el-col :span="24">-->
      <!--              <div class="label">申请公司</div>-->
      <!--              <div class="text">{{ printData.applyCompany }}</div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--        </div>-->
      <!--      </div>-->
      <div id="printable" style="width: 800px; border: 1px solid black;box-sizing: border-box;overflow:hidden;margin: 20px 10px 0">
        <!-- 头部 -->
        <div style="width: 800px;border-bottom: 1px solid black;box-sizing: border-box">
          <div style="display: flex;justify-content: center; align-items: center;padding: 6px 0">
            <div style="display: flex;align-items: center">
              <div ref="qrcode" style="width: 80px;height: 80px;" />
              <div style="font-size: 16px;margin-left: 20px">锐捷网络有限公司2022年 新市场活动核销单（渠道）</div>
            </div>
          </div>
        </div>
        <!--内容-->
        <div style="border-left: none;border-top: none;overflow: hidden">
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                经办人
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.handler }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                单据编号
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.instanceCode }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                核销人
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.writeOffPerson }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                区域
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.region }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                部门
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.departMentName }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                岗位
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.postName }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                货币种类
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.currency }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                汇率
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.exchangeRate }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                填单日期
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.fillFromDate }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                核销金额
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.writeOffAmount }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                实付金额
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.realPayAmount }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                借款冲销情况
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                无
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                借款总金额
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                0.00
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                活动单号
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.activityCode }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                用款说明
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                无
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                开支金额
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                （大写）{{ printData.realPayAmountBig }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                （小写）{{ printData.realPayAmount }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;border-right: 1px solid black">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                实付金额
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                （大写）{{ printData.realPayAmountBig }}
              </div>
            </div>
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                （小写）{{ printData.realPayAmount }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="text" style="flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;">
                营销费用明细
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;line-height: 22px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                费用归属
              </div>
              <div class="text" style="width: 100%;flex: 1; display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.expenseDeptName }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 22px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                费用项目
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.expenseType }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 22px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                申请使用金额
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.applyAmount }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 22px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                借款金额
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;border-right: 1px solid black">
                0.00
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 22px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;">
                分摊核销金额
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;">
                0.00
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="text" style="flex: 1;display:flex; justify-content: center; align-items: center;padding: 6px;min-height: 44px;">
                付款明细
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;border-bottom: 1px solid black">
            <div class="col" style="flex: 1;line-height: 18px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                户名
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 10px 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.bankAcountName }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 18px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                付款方式
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 10px 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.payType }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 18px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                账号
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 10px 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.bankAcount }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 18px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;border-right: 1px solid black">
                开户银行
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 10px 6px;min-height: 44px;border-right: 1px solid black">
                {{ printData.bankName }}
              </div>
            </div>
            <div class="col" style="flex: 1;line-height: 18px;display: flex; flex-direction: column;">
              <div class="label" style="width: 100%;display:flex; justify-content: center; align-items: center;padding: 0 6px 0 10px;min-height: 44px;border-bottom: 1px solid black;">
                实付金额
              </div>
              <div class="text" style="width: 100%;flex: 1;display:flex; justify-content: center; align-items: center;padding: 10px 6px;min-height: 44px;">
                {{ printData.realPayAmount }}
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;">
            <div class="col" style="flex: 1;display: flex;line-height: 22px;">
              <div class="label" style="width: 92px;display:flex; align-items: center;padding: 0 6px 0 10px;border-right: 1px solid black">
                申请公司
              </div>
              <div class="text" style="flex: 1;display:flex; align-items: center;padding: 6px;min-height: 44px;">
                {{ printData.applyCompany }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2';
// import downloadPDF from '@/utils/htmlToPdf';
import print from 'print-js';
export default {
  data () {
    return {
      dialogVisible: false
    };
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    printData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    dialogShow (val) {
      if (val) {
        this.qrCode(this.printData.instanceCode);
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    printHandler () {
      // let basicInfoDom = document.querySelector('.billsCreateDialog .generatedContent');
      // downloadPDF(basicInfoDom, `锐捷网络有限公司2022年 新市场活动核销单（渠道） - ${ this.printData.instanceCode }`);
      // const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
      printJS({
        printable: 'printable',
        type: 'html',
        header: null,
        targetStyles: ['*'],
        style: `
          @page {margin:0 10mm}
        `
      });
    },
    qrCode (url) {
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = '';
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 80, // 图像宽度        height: 150, //图像高度        colorDark : "#000000", //前景色        colorLight : "#ffffff", //背景色        typeNumber:4,         correctLevel : QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
          height: 80
        });
        qrcode.makeCode(url); // 生成另一个新的二维码
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
.billsCreateDialog{
  .wrapper{
    padding-bottom: 30px;
    >.btnBar{
      display: flex;
      justify-content: right;
      margin-right: 10px;
    }
    >.generatedContent {
      >.title {
        border: 1px solid #DEE1E7;
        display: flex;
        justify-content: center;
        border-bottom: none;
        >div{
          display: flex;
          align-items: center;
          padding: 6px 0;
          >.qrCode {
            width: 80px;
            height: 80px;
          }
          >.text {
            font-size: 16px;
            margin-left: 20px;
          }
        }
      }
      .container{
        border: 1px solid #DEE1E7;
        border-left: none;
        border-top: none;
        overflow: hidden;
        >.el-row{
          display: flex;
          >.el-col{
            //background: #F6F7F9;
            border: 1px solid #DEE1E7;
            border-right: none;
            border-bottom: none;
            margin: 0 -1px -1px 0;
            line-height: 22px;
            box-sizing: content-box;
            >.label,>.title{
              background: #F6F7F9;
              min-height: 44px;
              display: flex;
              align-items: center;
              position: relative;
              &:before {
                content: '';
                width: 100%;
                height: 1px;
                background: #FFFFFF;
                position: absolute;
                top: 0;
              }
            }
            >.title{
              flex: 1;
              justify-content: center;
            }
            >.text{
              display: flex;
              align-items: center;
              padding: 6px;
              min-height: 44px;
            }
          }
          &.transverse{
            >.el-col{
              display: flex;
              >.label {
                min-width: 120px;
                padding: 0 6px 0 20px;
                border-right: 1px solid #DEE1E7;
              }
            }
          }
          &.longitudinal{
            >.el-col{
              >.label {
                justify-content: center;
                border-right: 1px solid #DEE1E7;
                border-bottom: 1px solid #DEE1E7;
              }
              >.text{
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>
